import api from '../../Auth/api'
import { createEffect, createEvent, createStore } from 'effector';

export const $autocompleteSearch = createStore({});
export const cleanSearch = createEvent();

export const $searchLoading = createStore(false);
export const setSearchLoading = createEvent();

$searchLoading.on(setSearchLoading, (_, payload) => {
    return payload;
});

$searchLoading.on(setSearchLoading, (_, payload) => {
    return payload;
});

export const searchItemFx = createEffect(async ({ key, value }) => {
    const response = await api.post(`/${key}`, {
        query: value
    });

    return response;
});

$autocompleteSearch.on(searchItemFx.done, (state, { result, params }) => {
    setSearchLoading(true);
    return {
        [params.key]: result.data.data
    };
});

$autocompleteSearch.on(searchItemFx.fail, () => {
    return {};
});

$autocompleteSearch.on(searchItemFx.finally, () => {
    setSearchLoading(false);
});
